// extracted by mini-css-extract-plugin
export default {"fundTag":"FundTags_fundTag__FS0jm","newFundTag":"FundTags_newFundTag__lga0x"};